<a [routerLink]="previousUrl">Return to previous</a>
<div class="flex flex-row my-12 gap-4">
    <div>
        <i class="fa-regular fa-circle-xmark text-8xl text-red-400"></i>
    </div>
    <div class="flex flex-col">
        <h1>Permission Denied</h1>
        <div>You do not have permission to access this feature. Please contact your system administrator to review and provide access.</div>
    </div>
</div>